<template>
    <v-menu
            :close-on-content-click="menu"
            min-width="250"
            offset-y
            class="mt-20"
    >
        <template v-slot:activator="{ on, attrs }">
            <v-badge
                    :content="messages"
                    :value="messages"
                    color="error"
                    overlap
            >
                <v-btn
                        fab
                        dark
                        x-small
                        color="primary"
                        link
                        v-on="on"
                >
                    <v-icon>
                        mdi-message-processing
                    </v-icon>
                </v-btn>
            </v-badge>
        </template>
        <v-card
                class="mx-auto"
                max-width="500"
                max-height="500"
                v-if="messages > 0"
        >
            <v-card-title>
                <h2 class="text-h6">
                    Invoice Notification
                </h2>
                <v-spacer></v-spacer>
                <a class="subtitle-2" @click.prevent.stop="setMarkAsRead('all')">Mark as all read</a>
            </v-card-title>
            <v-divider></v-divider>
            <v-list two-line>
                <v-list-item-group
                        v-model="selected"
                        active-class="pink--text"
                        return-object
                        @change="setMarkAsRead($event)"
                >
                    <template v-for="(item, index) in items">
                        <v-list-item :key="item.title">
                            <template v-slot:default="{ active }">
                                <v-list-item-content>
                                    <v-list-item-title> Invoice No. #{{item.invoiceNo}}
                                        <g-payment-status-chip v-if="item.isDeleted" text="Deleted" color="blue"/>
                                        <g-payment-status-chip v-else-if="item.paymentStatus === 100"/>
                                        <g-payment-status-chip v-else-if="item.paymentStatus === 200" color="green" text="Paid"/>
                                        <g-payment-status-chip v-else-if="item.paymentStatus === 400" color="blue" text="Refund"/>
                                        <g-payment-status-chip v-else-if="item.paymentStatus === 600" color="orange" text="Republish"/>
                                    </v-list-item-title>
                                    <v-list-item-subtitle
                                            class="text--primary"
                                            v-text="item.email"
                                    ></v-list-item-subtitle>
                                    <v-list-item-subtitle v-html="getText(item)"></v-list-item-subtitle>
                                </v-list-item-content>

                                <v-list-item-action>
                                    <v-list-item-action-text v-text="getTimeDiff(item.paymentDate)"></v-list-item-action-text>
                                    <v-icon
                                            v-if="!active"
                                            color="grey lighten-1"
                                    >
                                        mdi-star-outline
                                    </v-icon>

                                    <v-icon
                                            v-else
                                            color="yellow darken-3"
                                    >
                                        mdi-star
                                    </v-icon>
                                </v-list-item-action>
                            </template>
                        </v-list-item>

                        <v-divider
                                v-if="index < items.length - 1"
                                :key="index"
                        ></v-divider>
                    </template>
                </v-list-item-group>
                <div
                        v-if="!isLastPage"
                        v-observe-visibility="{callback: visibilityChanged}"
                        class="d-flex justify-center mb-6"
                >
                    <v-progress-circular
                            indeterminate
                            color="primary"
                    />
                </div>
            </v-list>
        </v-card>
    </v-menu>
</template>

<script>
    import Invoice from "../services/Invoice";
    import DateHelper from "./mixins/DateHelper";
    import GPaymentStatusChip from "./GPaymentStatusChip";
    export default {
        name: "Notification",
        components: {
            GPaymentStatusChip
        },
        mixins: [DateHelper],
        data() {
            return {
                menu: false,
                messages: 0,
                isLastPage: false,
                isShowLoading: true,
                selected: [],
                items: [],
                pagination: {
                    page: 1,
                    rowsPerPage: 10,
                    descending: true,
                    sortBy: 'paymentDate'
                },
                currentPage: 0
            }
        },
        mounted() {
            this.connect();
            this.getMessages();
        },
        methods: {
            visibilityChanged(e) {
                if(e) {
                    this.getMessages(true);
                }
            },
            getMessages(newPage = false) {
                this.selected = [];
                if (newPage) {
                    ++this.currentPage;
                } else {
                    this.currentPage = 1;
                }

                this.pagination.page = this.currentPage;

                Invoice
                    .getAllUnreadMessages(this.pagination)
                    .then((response) => {
                        this.items = this.items.concat(response.data.data);
                        this.isLastPage = this.items.length === response.data.total;
                        this.messages = response.data.total;
                        this.isShowLoading = false;
                    })
            },
            connect() {
                let channel = this.$pusher.subscribe('private-payment-channel');
                let me = this;
                channel.bind('payment-notification-channel', (data)=> {
                    me.items = [];
                    me.getMessages();
                })
            },
            setMarkAsRead(event) {
                let id = '';
                if(event === 'all') {
                    id = 'all';
                } else {
                    let item = this.items[event];
                    id = item.id;
                }

                Invoice.invoiceMarkAsRead({id})
                    .then(({data}) => {
                        this.$store.commit('SET_SNACKBAR', {text: data.message, type: 'info'});
                        this.currentPage = 1;
                        this.items = [];
                        this.getMessages();
                    })
            },
            getText(item) {
                let text = '';
                if(item.isDeleted) {
                    text = text + `This invoice has been deleted `;
                } else if (item.paymentStatus === 200) {
                    text = text + `Payment has been paid with <strong>${item.methods ? item.methods.name : ''}</strong> `;
                } else if (item.paymentStatus === 100) {
                   text = text + `This invoice has been newly created `;
                }else if (item.paymentStatus === 400) {
                   text = text + `This invoice has been refund `;
                }else if (item.paymentStatus === 600) {
                   text = text + `This invoice needed to republish `
                } else {
                    text = text + `This invoice has been newly created `
                }

                text = text + `and total amount is $${item.totalAmount}`

                return text;
            }
        }
    }
</script>

<style type="scss" scoped>
    .v-chip.v-size--default {
        height: 20px !important;
    }

    .v-card__subtitle, .v-card__text, .v-card__title {
        padding: 10px !important;
    }
</style>